import {LitElement, html, nothing} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {style} from './ch-article-info.styles';

@customElement('sbk-ch-article-info')
export class Banner extends LitElement {

    @property({type: String})
    date = ''

    @property({attribute: 'reading-time'})
    readingTime = ''

    @property({attribute: 'author-label'})
    authorLabel = ''

    @property({attribute: 'author'})
    author = ''

    @property({attribute: 'author-link'})
    authorLink = ''

    @property({attribute: 'quality-assurance-specialists'})
    qualityAssuranceSpecialists = ''

    @property({attribute: 'quality-assurance-specialists-link'})
    qualityAssuranceSpecialistsLink = ''

    @property({attribute: 'quality-assurance-specialists-label'})
    qualityAssuranceSpecialistsLabel = ''

    static get styles() {
        return style;
    }

    render() {
        if (this.readingTime) {
            return html`
                <div class="article-info">
                    ${this.additionalInfos()}
                    <span>${this.date}</span>
                    <span class="article-info__reading-time">${this.readingTime}</span>
                </div>
            `
        } else {
            return html`
                <div class="article-info">
                    <span>${this.date}</span>
                </div>
            `
        }
    }

    additionalInfos() {
        if (this.author || this.qualityAssuranceSpecialists) {
            return html`
                <div class="article-info__additional-infos">
                    ${this.author ? this.authorTemplate() : nothing}
                    ${this.qualityAssuranceSpecialists ? this.qualityTemplate() : nothing}
                </div>
            `
        }
    }

    authorTemplate() {
        if (this.authorLink) {
            return html`
                <span>
                    <sbk-icon symbol="author"></sbk-icon><span class="label">${this.authorLabel}</span>
                    <sbk-link href=${this.authorLink}>${this.author}</sbk-link>
                </span>
            `
        } else {
            return html`
                <span><sbk-icon symbol="author"></sbk-icon><span class="label">${this.authorLabel}</span>${this.author}</span>
            `
        }
    }

    qualityTemplate() {
        if (this.qualityAssuranceSpecialistsLink) {
            return html`
                <span>
                    <sbk-icon symbol="quality-check"></sbk-icon><span
                        class="label">${this.qualityAssuranceSpecialistsLabel}</span>
                    <sbk-link
                            href=${this.qualityAssuranceSpecialistsLink}>${this.qualityAssuranceSpecialists}</sbk-link>
                </span>
            `
        } else {
            return html`
                <span><sbk-icon
                        symbol="quality-check"></sbk-icon><span
                        class="label">${this.qualityAssuranceSpecialistsLabel}</span>${this.qualityAssuranceSpecialists}</span>
            `
        }
    }
}
